import React, { memo } from 'react'

/** 把hook的return object,利用HOC inject到component中 */
export function bind<P, T extends object>(
  Component: React.FunctionComponent<T>,
  useViewModelHook: (props?: P) => T,
) {
  return memo((props) => {
    if (typeof useViewModelHook !== 'function') {
      throw Error('Error occur at bind function ViewModel Must be a function')
    }

    const viewModelReturn = useViewModelHook(props as P) ?? {}
    return <Component {...viewModelReturn} />
  })
}
